<template>
  <div class="flex flex-row items-center justify-start relative mb-16">

    <div :class="`absolute -top-20 left-0 alert alert-${warning.type} alert-dismissible fade ${warning.visible ? '' : 'hidden'}`" role="alert">
      <span>{{ warning.message }}</span>
      <button type="button" class="btn btn-white" @click="warning.visible = false">sluit melding</button>
    </div>
  

    <div class="hover:cursor-pointer flex flex-row items-center" @click="$emit('navigate', 1)">
      <img src="/wp-content/themes/teachdigital/dist/img/ic_checkout_step1.svg" alt="Stap 1: Aanbieder" width="33" height="33" />
      <span class="font-bold text-lg ml-1 lg:ml-3">Aanbieder</span>
    </div>

    <div class="mx-4 md:mx-12 block">
      <img src="/wp-content/themes/teachdigital/dist/img/ic_checkout_stepseperator.svg" alt="Next step" />
    </div>

    <div class="hover:cursor-pointer flex flex-row items-center" @click="firstStepCompleted ? $emit('navigate', 2) : setWarning()" :class="!firstStepCompleted ? 'opacity-25' : 'opacity-100'">
      <img src="/wp-content/themes/teachdigital/dist/img/ic_checkout_step2.svg" alt="Stap 2: Gegevens" width="33" height="33" />
      <span class="font-bold text-lg ml-1 lg:ml-3">Gegevens</span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    step: {
      type: Number,
      default: 1,
      required: true
    },
    firstStepCompleted: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      warning: {
        visible: false,
        type: 'primary',
        message: 'Selecteer eerst een aanbieder om door te gaan naar stap 2.'
      }
    }
  },
  methods: {
    setWarning() {
      this.warning.visible = true;
    }
  }
}
</script>